import {BaseModel, attr} from "../../lib/itn-ui-kit/data";

export default class ServiceModel extends BaseModel {

  @attr('datetime') createdAt;
  @attr('datetime') updatedAt;
  @attr('string') serviceName;
  @attr('string') serviceCode;
  @attr('string') description;
  @attr('string') createdBy;
  @attr('string') updatedBy;
}
